import { render, staticRenderFns } from "./DragTable.vue?vue&type=template&id=42de0058&"
import script from "./DragTable.vue?vue&type=script&lang=js&"
export * from "./DragTable.vue?vue&type=script&lang=js&"
import style0 from "./DragTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports